import { Facebook, Instagram, ArrowUpRight } from "lucide-react";
import { FACEBOOK_URL, INSTAGRAM_URL } from "../lib/constants";

export default function FacebookSection() {
  return (
    <section
      data-testid="facebook-section"
      className="relative bg-[var(--fb-bg)] pb-20 md:pb-24"
    >
      <div className="fb-container">
        <div className="relative overflow-hidden rounded-3xl border border-[var(--fb-line)] bg-white">
          <div className="grid md:grid-cols-2">
            <div className="p-8 md:p-12 lg:p-14 reveal">
              <span className="eyebrow">Más obras</span>
              <h2 className="mt-5 font-display text-3xl md:text-4xl lg:text-5xl text-[var(--fb-ink)] font-medium tracking-tight balance leading-[1.05]">
                Seguinos en redes
              </h2>
              <p className="mt-4 text-[var(--fb-ink-soft)] text-base md:text-[17px] max-w-md pretty">
                En nuestras redes publicamos nuevas obras, avances de proyectos
                y trabajos terminados. Es la mejor forma de seguir lo que
                hacemos día a día.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href={FACEBOOK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="facebook-cta-btn"
                  className="btn-primary"
                >
                  <Facebook className="h-5 w-5" />
                  Ver en Facebook
                  <ArrowUpRight className="h-4 w-4" />
                </a>
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="instagram-cta-btn"
                  className="btn-ghost !border-b-0 inline-flex items-center gap-2 px-5 py-3.5 rounded-full border border-[var(--fb-line)] hover:border-[var(--fb-ink)] hover:text-[var(--fb-ink)]"
                >
                  <Instagram className="h-5 w-5" />
                  Ver en Instagram
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </div>
            <div className="relative min-h-[280px] md:min-h-full">
              <img
                src="/photos/pergola_07.jpg"
                alt="Pérgola de madera vista cenital"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-white/40 md:to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
